<div class="login-container">

    <!-- LEFT: HERO SECTION -->
    <div class="hero-section">
        <div class="hero-content">
            <div class="brand-logo">
                <mat-icon>school</mat-icon> KSolve
            </div>
            <h1>Welcome Back!</h1>
            <p>Log in to access your dashboard, manage your profile, and continue your learning journey.</p>
        </div>
        <div class="hero-overlay"></div>
    </div>

    <!-- RIGHT: FORM SECTION -->
    <div class="form-section">
        <div class="form-wrapper">
            <div class="form-header">
                <h2>Sign In</h2>
                <p class="text-muted">Enter your details to proceed</p>
            </div>

            <form>
                <div class="mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email Address</mat-label>
                        <input matInput required [(ngModel)]="user.loginId" name="email" type="email"
                            placeholder="name@example.com">
                        <mat-icon matSuffix>email</mat-icon>
                    </mat-form-field>
                </div>

                <div class="mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Password</mat-label>
                        <input matInput type="password" required [(ngModel)]="user.password" name="password"
                            placeholder="********">
                        <mat-icon matSuffix>lock</mat-icon>
                    </mat-form-field>
                </div>

                <div class="actions d-flex justify-content-between align-items-center mb-4">
                    <mat-checkbox color="primary">Remember me</mat-checkbox>
                    <a href="javascript: void(0);" (click)="forgotPassword()" class="forgot-link">Forgot Password?</a>
                </div>

                <div class="buttons">
                    <button mat-raised-button color="primary" class="btn-block btn-lg" type="submit" (click)="login()">
                        LOGIN
                    </button>
                </div>

                <div class="register-link text-center mt-4">
                    <p>Don't have an account? <a href="javascript: void(0);" (click)="register()">Register Now</a></p>
                </div>
            </form>
        </div>
    </div>

</div>